import { render, staticRenderFns } from "./idCardRecognition.vue?vue&type=template&id=fe780a0e&scoped=true"
import script from "./idCardRecognition.vue?vue&type=script&lang=js"
export * from "./idCardRecognition.vue?vue&type=script&lang=js"
import style0 from "./idCardRecognition.vue?vue&type=style&index=0&id=fe780a0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe780a0e",
  null
  
)

export default component.exports